import React, { useRef, ReactNode, useEffect, memo } from 'react';

import { Paper } from 'e100-react-components';

import { MAP_INFO_WINDOW_ID } from '../../constants';

import { Map } from 'common/utils/Map/types/map';
import { Marker } from 'common/utils/MapMarker/types';

import { useMediaQuery } from 'common/hooks';
import { useUpdateInfoWindow } from '../../hooks';
import { useStyles } from './styles';

import {
  isGoogleMap,
  isHereMap
} from 'common/constants';

export const MapInfoWindow = memo(({
  coordinates,
  children,
  onClose,
  map,
  markers,
  onOpen = () => {},
  showCloseIcon
}: MapInfoWindowProps) => {
  const { isMobile } = useMediaQuery();
  const classes = useStyles({ isMobile });
  const rootRef = useRef<RootElementRef>(null);

  useUpdateInfoWindow({
    map,
    markers,
    coordinates,
    rootRef,
    showCloseIcon
  }, {
    onClose
  });

  useEffect(() => {
    onOpen();
  // eslint-disable-next-line 
  }, []);

  if (map && isHereMap(map.name)) {
    return (
      <div className={classes.container}>
        <div
          ref={rootRef}
          id={MAP_INFO_WINDOW_ID}
        >
          {children}
        </div>
      </div>
    )
  }

  if (map && isGoogleMap(map.name)) {
    return (
      <>
        <div
          className={classes.root}
          ref={rootRef}
          id={MAP_INFO_WINDOW_ID}
        >
          <Paper
            classes={{
              root: classes.paperRoot
            }}
          >
            {children}
          </Paper>
        </div>
      </>
    );
  }

  return null;
});

export type RootElementRef = HTMLDivElement | null;

export interface MapInfoWindowProps {
  coordinates?: [number, number] | null, // [latitude, longtitude]
  children: ReactNode;
  onClose?: () => void;
  map: Map | null;
  markers?: Marker | null;
  onOpen?: () => void;
  showCloseIcon?: boolean;
}